require("jquery")
window.$ = window.jQuery = $

require("../lib/kendo-ui/2023.1.314/js/kendo.all")
require("../lib/kendo-ui/2023.1.314/js/kendo.aspnetmvc")